<template>
	<div>
		<button class="btn btn-primary btn-sm" @click="openForm">Log Communication</button>
	</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
	name: "CommLogFormControl",
	props: {
		participant: Object
	},
	methods: {
		openForm() {
			this.$store.dispatch('communications/setFormOpen', true)
		}
	},
	mounted() {
		this.$store.dispatch('communications/setParticipant', this.participant)
        this.$store.dispatch('communications/setContacts', this.participant.contacts)
	}
}
</script>